module.exports = [{
      plugin: require('/Users/neil/Code/core-gui/ui/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
